module.exports = __webpack_public_path__ + "officialStatic/img/schoolA.a1e1796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/schoolA.png
// module id = ahUe
// module chunks = 0